let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eFTsD")).then(() => parcelRequire('Aa5aQ'));